// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e6116f37","455":"234988bc"}[chunkId] + ".chunk.js";
};